module.exports = __webpack_public_path__ + "static/media/favicon-512x512.a5fc83d2.png";